import md5 from 'js-md5';

export const pwdEncrypt: (OriginPwd: string) => string = OriginPwd => {
  if (OriginPwd.trim()) {
    return md5(OriginPwd.trim());
  }
  return '';
};
